<template>
  <img src="res/music.png" :class="{rotate:playing}" class="iconsize musicpos" @click="onClick" style="z-index:100;">
</template>

<script>
import { loadAndPlayAudioInWx } from "@/d";
const bgmusic = loadAndPlayAudioInWx();

let forceOff = false;

export function getExtends() {
  // let that = this;
  return {
    methods: {
      onPause() {
        // 视频关了，bg音乐原来是开的时候，才开
        this.$root.$emit("continuePlayMusic");
      },
      onPlay() {
        // 视频开了，bg音乐原来是开的，才关
        this.$root.$emit("pausePlayMusic");
      }
    }
  };
}

export default {
  data() {
    return {
      playing: !bgmusic.isPaused()
    };
  },

  props: {},

  mounted() {
    this.$root.$on("continuePlayMusic", this.continuePlayMusic);
    this.$root.$on("pausePlayMusic", this.pausePlayMusic);
  },
  beforeDestroy(){
    this.$root.$off("continuePlayMusic", this.continuePlayMusic);
    this.$root.$off("pausePlayMusic", this.pausePlayMusic);
  },

  methods: {
    continuePlayMusic() {
      if(forceOff) return;
      bgmusic.continuePlay();
      this.playing = !bgmusic.isPaused();
    },
    pausePlayMusic() {
      if(forceOff) return;
      bgmusic.pause();
      this.playing = !bgmusic.isPaused();
    },
    onClick() {
      if (bgmusic.isPaused()) {
        bgmusic.continuePlay();
      } else {
        bgmusic.pause();
      }
      forceOff = bgmusic.isPaused();
      this.playing = !forceOff;
    }
  },
  components: {}
};
</script>

<style lang="scss">
</style>
